import React from 'react'
import Form from "react-bootstrap/Form";
import { OverlayTrigger } from 'react-bootstrap';
import Tooltip from 'react-bootstrap/Tooltip';

// Component for negative prompt widget

// Negative prompt refers to text that a user supplies
// which refers to things they do NOT want to show up in the final generated image.

import { useState } from "react";

function NegativePrompt({negativePrompt}) {
    return (
        <div>
            Negative prompt
            <OverlayTrigger
                placement="top"
                overlay={
                    <Tooltip id="tooltip-disabled">
                        Negative prompts let you specify what you don't want to see in your picture.
                    </Tooltip>
                }
            >
                <span style={{ marginLeft: "0.5vw" }}>ⓘ</span>
            </OverlayTrigger>
            <Form.Control
                id="negative_prompt"
                className="me-auto"
                placeholder="Type here..."
            >{negativePrompt}</Form.Control>
        </div>
    )
}

export default NegativePrompt